// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"876de5bb","453":"8b6d8cda","657":"375ca102"}[chunkId] + ".chunk.js";
};